import { setPageTitle } from "components/common/Utils";
import { formatDate } from "helpers/common_helpers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { myCurrentSubscription } from "store/actions/subscriptionSlice";

function MyPlan() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [planType, setPlanType] = useState(null);
  const [selectedTab, setSelectedTab] = useState(1);
  setPageTitle("Overview Dashboard" ,t);


  const { loading, isLoading, allPlans, mySubscriptionDetails } = useSelector(
    (state) => state.Subscriptions
  );
  useEffect(() => {
    dispatch(myCurrentSubscription()).then((action) => {
      console.log(action);
    });
  }, []);
  useEffect(() => {
    if (mySubscriptionDetails && !loading) {
      const { subscriptionType, screenCount } = mySubscriptionDetails || {};
      const updatedPlanType =
        subscriptionType === "FREE_TRIAL" ? "MONTHLY" : subscriptionType;

      setPlanType(updatedPlanType);
    }
  }, [mySubscriptionDetails]);

  // const dispatch = useSelector();

  return (
    <div className="my_plan_page common_page">
      <div className="container">
        <div className="w-100 row">
          <div className="g_between gap-2 gap-sm-3">
            <h1 className="main_title">{t("My Plan")}</h1>
          </div>
        </div>
        <div className="common_wrapper">
          <div className="row">
            <div className="col-lg-6">
              <div className="tab_btns">
                <button
                  className={selectedTab === 1 ? "active" : ""}
                  onClick={() => setSelectedTab(1)}
                >
                  {t("Plan Info")}
                </button>
                <button
                  className={selectedTab === 2 ? "active" : ""}
                  onClick={() => setSelectedTab(2)}
                >
                  {t("Billing History")}
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="common_card_2 mt-0">
                <div className="g_between gap-3 align-items-start flex-wrap">
                  <div className="plan_div align-items-start">
                    <div className="box"></div>
                    <div>
                      <h2 className="fs_12 text_dark_gray">{t("Plan")}</h2>
                      <h2 className="fs_20 text_black text-capitalize">
                        {mySubscriptionDetails.billingCycle}
                      </h2>
                    </div>
                  </div>
                  <div className="cancel_subscription_plan">
                    <button className="cancel_btn_2 d-block ms-auto">
                      Cancel Subscription
                    </button>
                  </div>
                </div>
                <div className="plan_details">
                  <div className="single_details">
                    <h2 className="fs_12 text_dark_gray">{t("Due On")}</h2>
                    <h2 className="fs_14 text_black_3">
                      {formatDate(mySubscriptionDetails?.trialEndDate)}
                    </h2>
                  </div>
                  <div className="single_details">
                    <h2 className="fs_12 text_dark_gray">{t("Charged")}</h2>
                    <h2 className="fs_14 text_black_3">
                      {mySubscriptionDetails?.subscriptionType}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="common_wrapper">
          <div className="row">
            <div className="col-lg-6"></div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="common_card_2 mt-0">
                <h2 className="fs_20 text_black_2">Update Your Plan</h2>
                <div className="d-md-flex gap-4">
                  <div className="current_plan update_plan_div active">
                    <div className="current_plan_text">Current Plan</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyPlan;
